import { render, staticRenderFns } from "./siWorkspace.vue?vue&type=template&id=3af2cd0c&scoped=true&"
import script from "./siWorkspace.vue?vue&type=script&lang=js&"
export * from "./siWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./siWorkspace.vue?vue&type=style&index=0&id=3af2cd0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2cd0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af2cd0c')) {
      api.createRecord('3af2cd0c', component.options)
    } else {
      api.reload('3af2cd0c', component.options)
    }
    module.hot.accept("./siWorkspace.vue?vue&type=template&id=3af2cd0c&scoped=true&", function () {
      api.rerender('3af2cd0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/siWorkspace.vue"
export default component.exports